export class LogSearchConditionModel {

  /* ログ検索するテーブル */
  /* 商品マスタ：１、企画マスタ：２、指定しない：３ */
  public searchTableCondition: number;
  /* 受注コード */
  public orderCode: string = <string>'';
  /* クープコードリスト */
  public coopCodeList: Array<any> = new Array<any>();
  /* Pコード */
  public pcode: string = <string>'';
  /* アイテムコード */
  public itemCode: string = <string>'';
  /* ユーザーID */
  public userID: string = <string>'';
  /* 更新日From */
  public updateDateFrom: string = <string>'';
  /* 更新日To */
  public updateDateTo: string = <string>'';
  /* 表示ページ番号 */
  public pageNum: number;
  /* DBソートカラム名 */
  public sortColumnName: string = <string>'';
  /* ソート種類 */
  public sortKind: string = <string>'';

}
